import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import './options.sass';
import { Checkbox, FormControlLabel, IconButton, ListItem, Menu, Slider, Typography, } from '@mui/material';
import { MapOptionsMenu } from './map-options-menu';
import { connect } from 'react-redux';
import { select_ui_settings, set_ui_settings, } from 'console/redux/settings-actions';
const size_marks = [
    { value: 24, label: 'Мин' },
    { value: 72, label: 'Макс' },
];
const accuracy_range = [
    { value: 20, label: '20м' },
    { value: 2000, label: '∞' },
];
const initialCoordinatesMenu = { mouseX: null, mouseY: null };
function getAnchorPosition(coordinates) {
    return coordinates.mouseY != null && coordinates.mouseX != null
        ? {
            top: coordinates.mouseY,
            left: coordinates.mouseX,
        }
        : undefined;
}
function setCoordinates(setCoord, setCoordGeneral) {
    return (event) => {
        event.preventDefault();
        setCoord({
            mouseX: event.clientX,
            mouseY: event.clientY - 4,
        });
        setCoordGeneral?.(initialCoordinatesMenu);
    };
}
function MapOptionsImpl(props) {
    const { marker_size, onWantMarkerSize, hide_gsm_points, onWantHideGSMPoints, accuracy_limit, onWantAccuracyLimit, hide_for_map_dashboard, } = props;
    const [coordinates_general_menu, setCoordinatesGeneralMenu] = useState(initialCoordinatesMenu);
    const [coordinates_marker_size, setCoordinatesMarkerSize] = useState(initialCoordinatesMenu);
    const [coordinates_accuracy_shown, setCoordinatesAccuracyShown] = useState(initialCoordinatesMenu);
    const [marker_size_changed, setMarkerSize] = useState(marker_size);
    const [accuracy_range_changed, setAccuracyRange] = useState(accuracy_limit);
    const max_accuracy_limit = accuracy_range[1].value;
    const onOptionOpen = useCallback(setCoordinates(setCoordinatesGeneralMenu), [
        setCoordinatesGeneralMenu,
    ]);
    const onCloseOption = useCallback(() => {
        setCoordinatesGeneralMenu(initialCoordinatesMenu);
        setCoordinatesMarkerSize(initialCoordinatesMenu);
        setCoordinatesAccuracyShown(initialCoordinatesMenu);
    }, [
        setCoordinatesGeneralMenu,
        setCoordinatesMarkerSize,
        setCoordinatesAccuracyShown,
    ]);
    const onShowMarkerSize = useCallback(setCoordinates(setCoordinatesMarkerSize, setCoordinatesGeneralMenu), [setCoordinatesMarkerSize, setCoordinatesGeneralMenu]);
    const onShowAccuracy = useCallback(setCoordinates(setCoordinatesAccuracyShown, setCoordinatesGeneralMenu), [setCoordinatesAccuracyShown, setCoordinatesGeneralMenu]);
    const onChangeMarkerSize = useCallback((event, newSize) => {
        setMarkerSize(newSize);
        onWantMarkerSize(newSize);
    }, [setMarkerSize, onWantMarkerSize]);
    const onChangeAccuracyRange = useCallback((event, newLimit) => {
        setAccuracyRange(newLimit);
        newLimit != null
            ? onWantAccuracyLimit(newLimit)
            : max_accuracy_limit;
    }, [setAccuracyRange, onWantAccuracyLimit, max_accuracy_limit]);
    const onCloseMenu = useCallback(() => {
        setCoordinatesMarkerSize(initialCoordinatesMenu);
    }, [setCoordinatesMarkerSize, initialCoordinatesMenu]);
    const onCloseAccuracyMenu = useCallback(() => {
        setCoordinatesAccuracyShown(initialCoordinatesMenu);
    }, [setCoordinatesAccuracyShown, initialCoordinatesMenu]);
    const onHideGSMPoints = useCallback(() => {
        onWantHideGSMPoints(!hide_gsm_points);
    }, [onWantHideGSMPoints, hide_gsm_points]);
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { "aria-controls": "option-menu", "aria-haspopup": "true", className: "ui-map-options-button ui-icon-map-button-options", title: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043A\u0430\u0440\u0442\u044B", onClick: onOptionOpen, size: "large" }), _jsx(MapOptionsMenu, { menu_coordinates: coordinates_general_menu, onClose: onCloseOption, onShowMarkerSize: onShowMarkerSize, onShowAccuracy: onShowAccuracy, hide_for_map_dashboard: hide_for_map_dashboard }), !hide_for_map_dashboard && (_jsx(Menu, { id: "marker-size-menu", open: coordinates_marker_size.mouseY != null, anchorReference: "anchorPosition", anchorPosition: getAnchorPosition(coordinates_marker_size), keepMounted: true, onClose: onCloseMenu, children: _jsx(ListItem, { children: _jsxs("div", { className: "r-map-options-popup", children: [_jsx(Typography, { children: "\u0420\u0430\u0437\u043C\u0435\u0440 \u0438\u043A\u043E\u043D\u043E\u043A \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432" }), _jsx(Slider, { min: 24, max: 72, step: 6, marks: size_marks, value: marker_size_changed, onChange: onChangeMarkerSize })] }) }) })), !hide_for_map_dashboard && (_jsx(Menu, { id: "accuracy-menu", open: coordinates_accuracy_shown.mouseY != null, anchorReference: "anchorPosition", anchorPosition: getAnchorPosition(coordinates_accuracy_shown), keepMounted: true, onClose: onCloseAccuracyMenu, children: _jsx(ListItem, { children: _jsxs("div", { className: "r-map-options-popup", children: [_jsx(FormControlLabel, { label: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E GPS-\u0442\u043E\u0447\u043A\u0438", control: _jsx(Checkbox, { checked: hide_gsm_points, color: "primary", onClick: onHideGSMPoints }) }), _jsx(Typography, { children: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C GSM-\u0442\u043E\u0447\u043A\u0438 \u0441 \u0442\u043E\u0447\u043D\u043E\u0441\u0442\u044C\u044E \u0432\u044B\u0448\u0435" }), _jsx(Slider, { min: 20, max: max_accuracy_limit, step: 20, marks: accuracy_range, value: accuracy_range_changed ?? 0, valueLabelDisplay: "auto", disabled: hide_gsm_points, onChange: onChangeAccuracyRange })] }) }) }))] }));
}
export const MapOptions = connect((state) => ({
    marker_size: select_ui_settings(state).map?.marker_size ?? 32,
    hide_gsm_points: select_ui_settings(state)?.hide_gsm_points ?? false,
    accuracy_limit: select_ui_settings(state).accuracy_limit ?? 0,
}), (dispatch) => ({
    onWantMarkerSize: (marker_size) => dispatch(set_ui_settings({ map: { marker_size } })),
    onWantHideGSMPoints: (hide_gsm_points) => dispatch(set_ui_settings({ hide_gsm_points })),
    onWantAccuracyLimit: (accuracy_limit) => dispatch(set_ui_settings({ accuracy_limit })),
}))(MapOptionsImpl);
